export const iconFontAwesomeMoneyHryvniaSign = (
	<i className="fa-solid fa-hryvnia-sign"></i>
);
